import { SideBarDef } from 'ag-grid-community';
import { agGridAmpDarkTheme, agGridBaseTheme } from 'Core-utils/agGridTheme';

export const customTheme = agGridBaseTheme;

export const findingsTheme = agGridAmpDarkTheme;

export const COLUMN_STATE_STORAGE_KEYS = {
  server: 'engagementLogsGridColumnState',
  queryStringParams: 'agGridEngagementLogs_queryStringParams'
} as const;

export const COLUMN_MIN_WIDTHS = {
  EXTRA_LONG_TEXT: 800,
  LONG_TEXT: 600,
  MEDIUM_TEXT: 400,
  SHORT_TEXT: 200,
  MINI_TEXT: 125,
};

export const DEFAULT_COL_DEF = {
  minWidth: 50,
  resizable: true,
  sortable: true,
  filter: false,
  floatingFilter: false,
  suppressHeaderContextMenu: true,
  suppressHeaderMenuButton: true,
  wrapHeaderText: true,
  autoHeaderHeight: true,
};

export const GRID_CONFIG = {
  rowHeight: 40,
  headerHeight: 40,
  cacheBlockSize: 25,
  defaultHeight: '37.5rem',
  minHeight: '25rem',
  paginationPageSize: 50,
  pivotMode: false,
  pivotPanelShow: 'never',
  sideBar: {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressPivots: true,
          suppressPivotMode: true,
          suppressRowGroups: true,
          suppressValues: true,
        }
      }
    ],
    hiddenByDefault: false,
    position: 'left',
  } as unknown as SideBarDef,
} as const;

export interface AgGridEngagementLogsProps {
  title?: string;
  defaultFilter?: Record<string, any>;
  tableBodyHeight?: string;
}

/** Default visible columns (in order): Updated At, User, Finding Status, Base Message, Started At, Channel, Engagement Status. Default sort: updatedAt DESC. */
export const DEFAULT_COLUMN_STATE = [
  { colId: 'updatedAt', width: null, hide: false, pinned: null, sort: 'desc', flex: 0.5 },
  { colId: 'user', width: null, hide: false, pinned: null, sort: null, flex: 0.5 },
  { colId: 'findingStatus', width: null, hide: false, pinned: null, sort: null, flex: 0.5 },
  { colId: 'baseMessage', width: null, hide: false, pinned: null, sort: null, flex: 3 },
  { colId: 'engagementCreatedAt', width: null, hide: false, pinned: null, sort: null, flex: 0.5 },
  { colId: 'channel', width: null, hide: false, pinned: null, sort: null, flex: 0.5 },
  { colId: 'engagementStatus', width: null, hide: false, pinned: null, sort: null, flex: 0.5 },
  { colId: 'id', width: null, hide: true, pinned: null, sort: null, flex: 0.5 },
  { colId: 'userDepartment', width: null, hide: true, pinned: null, sort: null, flex: 0.5 },
  { colId: 'assetName', width: null, hide: true, pinned: null, sort: null, flex: 0.5 },
  { colId: 'findingKind', width: null, hide: true, pinned: null, sort: null, flex: 0.5 },
  { colId: 'findingDescription', width: null, hide: true, pinned: null, sort: null, flex: 0.5 },
  { colId: 'findingSeverity', width: null, hide: true, pinned: null, sort: null, flex: 0.5 },
  { colId: 'findingAge', width: null, hide: true, pinned: null, sort: null, flex: 0.5 },
  { colId: 'vulnerabilityAffectedApp', width: null, hide: true, pinned: null, sort: null, flex: 0.5 },
  { colId: 'vulnerabilityRemediation', width: null, hide: true, pinned: null, sort: null, flex: 0.5 },
  { colId: 'engagement', width: null, hide: true, pinned: null, sort: null, flex: 0.5 },
  { colId: 'engagementStep', width: null, hide: true, pinned: null, sort: null, flex: 0.5 },
];
